// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { Entity, EntityT } from '../tbs/entity.js';


export class SetEntsAction implements flatbuffers.IUnpackableObject<SetEntsActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):SetEntsAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsSetEntsAction(bb:flatbuffers.ByteBuffer, obj?:SetEntsAction):SetEntsAction {
  return (obj || new SetEntsAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsSetEntsAction(bb:flatbuffers.ByteBuffer, obj?:SetEntsAction):SetEntsAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new SetEntsAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapSetEnts;
}

ents(index: number, obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

entsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

static startSetEntsAction(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapSetEnts);
}

static addEnts(builder:flatbuffers.Builder, entsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, entsOffset, 0);
}

static createEntsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startEntsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static endSetEntsAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createSetEntsAction(builder:flatbuffers.Builder, type:ActionType, entsOffset:flatbuffers.Offset):flatbuffers.Offset {
  SetEntsAction.startSetEntsAction(builder);
  SetEntsAction.addType(builder, type);
  SetEntsAction.addEnts(builder, entsOffset);
  return SetEntsAction.endSetEntsAction(builder);
}

unpack(): SetEntsActionT {
  return new SetEntsActionT(
    this.type(),
    this.bb!.createObjList<Entity, EntityT>(this.ents.bind(this), this.entsLength())
  );
}


unpackTo(_o: SetEntsActionT): void {
  _o.type = this.type();
  _o.ents = this.bb!.createObjList<Entity, EntityT>(this.ents.bind(this), this.entsLength());
}
}

export class SetEntsActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapSetEnts,
  public ents: (EntityT)[] = []
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const ents = SetEntsAction.createEntsVector(builder, builder.createObjectOffsetList(this.ents));

  return SetEntsAction.createSetEntsAction(builder,
    this.type,
    ents
  );
}
}
